<template>
  <base-material-alert
    v-if="!brokerSearchLoading && !brokerSearchBrokers.length"
    color="primary"
    icon="mdi-alert"
    :class="marginClass"
  >
    <div class="text-justify mr-4">
      {{ text }}
    </div>
    <div class="text-right mr-4">
      <router-link class="white--text" to="/accounts">
        {{ $t('views.common.brokerAlert.goToBrokerAccounts') }}
      </router-link>
    </div>
  </base-material-alert>
</template>

<script>
export default {
  props: {
    brokerSearchLoading: {
      type: Boolean,
      default: false,
    },
    brokerSearchBrokers: {
      type: Array,
      default: () => [],
    },
    marginClass: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style></style>
